import { render, staticRenderFns } from "./NgNewOrders.vue?vue&type=template&id=d31736d8"
import script from "./NgNewOrders.vue?vue&type=script&lang=js"
export * from "./NgNewOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports